import { Application } from '../../blocks/common/components/application';
import { CustomAppDevelopment } from '../../blocks/pages/custom-mobile-app-development/custom-app-development';


class Main extends Application {
    async init() {
        await super.init();

        const customAppDevelopment = new CustomAppDevelopment();
        customAppDevelopment.init(this.store);
    }
}

const application = new Main();
application.init();
window['application'] = application;